<template>
    <TrfSimpleModal
        :titulo="titulo"
        :isAtivo="isAtivo"
        :isModalPersonalizado="true"
        @close="fechar"
    >
        <div
            v-if="isAtivo"
            id="conteudo-modal"
            class="modal-list-content pt-0"
            @scroll="$event => TrfMixAderirAoInfiniteScroll($event, 'processos')"
            style="max-height:60vh; max-width:1024px; width:100%;"
        >
            <TrfSimpleTable
                :isCliente=false
                :isSelectable="false"
                :hasSlotLine="true"
                :isToggleble="true"
                :isMultipleSelection="false"
                :configuracaoDeColunas="configTabela.processos"
                :dados="dados"
                mensagemSemDados="Não há processos para este filtro."
                togglebleItem="fases"
            >
                <template #nomeNegocio={item}>
                    <p>
                        {{ item.nomePai ? item.nomePai : item.nomeNegocio }}<br />
                        <span v-if="!!item.nomePai" class="is-italic" style="font-size:0.9em;">Fase: {{ item.nome }}</span>
                    </p>
                </template>
                <template #slotLine={item}>
                    <tr v-if="hasFases(item)" class="is-togglable-row" style="background:#FFF!important">
                        <td colspan="1" class="p-0 m-0"></td>
                        <td colspan="6" class="p-0 m-0">
                            <TrfTabela
                                :containerClass="'tabela-fase-branca'"
                                :isStriped="false"
                                :showDropdownOptions="false"
                                :isButtonsDisplayed="false"
                                :showButtonsDefault="false"
                                :showEdit="false"
                                :isMultipleSelection="false"
                                :isSelectable="false"
                                :paginacao="false"
                                :data="item.fases"
                                :quantidadeDeItems="item.fases.length"
                                :dataConfig="configTabelaFases(item.fases)"
                                dataStatus=""
                                textoNadaEncontrado="Nenhuma fase foi encontrada."
                            />
                        </td>
                    </tr>
                    <tr v-if="hasFases(item)"></tr>
                </template>
            </TrfSimpleTable>
            <div v-if="TrfMixInfiniteScroll.listagemCarregando && !TrfMixInfiniteScroll.paginacaoFinalizada">
                <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
            </div>
        </div>
    </TrfSimpleModal>
</template>

<script>
import TrfSimpleModal from '../../../components/Modal/TrfSimpleModal.vue';
import TrfSimpleTable from '../../../components/SimpleTable';
import TrfTabela from "../../../components/Table";
import { TrfMixinInfiniteScroll } from '../../../mixins/infinitescroll';
import { utils } from '../../../util/utils.js';

export default {
    name: "ELegalizeModalListaProcessos",
    components: {
        TrfTabela,
        TrfSimpleModal,
        TrfSimpleTable
    },
    mixins: [TrfMixinInfiniteScroll],
    props: {
        titulo: {
            type: String,
            default: "Processos"
        },
        isAtivo: {
            type: Boolean,
            default: false
        },
        filtro: {
            type: Object,
            default: () => { }
        },
        listaDepartamentos: {
            type: Array,
            required: true,
            default: () => []
        },
        listaResponsaveis: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    emits: [
        'close'
    ],
    data() {
        return {
            configTabela: {
                processos: [{
                    titulo: "Nome do Negócio",
                    nome: "nomeNegocio",
                    referencia: ['nomeNegocio'],
                    divisor: "",
                    customStyle: "width: 35%;",
                    slot: true
                },
                {
                    titulo: "Data de entrega",
                    referencia: ['dataEntrega'],
                    divisor: ` - `,
                    customStyle: "white-space:nowrap; width: 15%;"
                },
                {
                    titulo: "Departamento",
                    referencia: ['departamento.nome'],
                    divisor: "",
                    customStyle: "white-space:nowrap; width: 30%;"
                },
                {
                    titulo: "Responsável",
                    referencia: ['responsavel.nome'],
                    divisor: "",
                    customStyle: "white-space:nowrap; width: 15%;"
                }]
            },
            dados: []
        }
    },
    methods: {
        async importProcessoService() {
            const { processoService } = await import('../../../service/processo-service.js')
            return processoService
        },
        configTabelaFases(fases) {
            return {
                columns: [{
                    name: "nome",
                    label: "Nome da fase",
                    style: "width: 35%;"
                },
                {
                    name: "dataEntrega",
                    label: "Data de entrega",
                    style: "white-space:nowrap; width: 15%;",
                },
                {
                    name: "nomeDepartamento",
                    label: "Departamento",
                    style: "white-space:nowrap; width: 30%;",
                },
                {
                    name: "nomeResponsavel",
                    label: "Responsável",
                    style: "white-space:nowrap; width: 15%;",
                }],
                itens: !fases ? [] : fases,
                itensSelected: [],
            }
        },
        fechar() {
            this.limparDados();
            this.$emit('close', false);
        },
        limparDados() {
            this.dados = [];
            this.TrfMixInfiniteScrollCustomConfig.processos.page = 1;
            this.TrfMixInfiniteScrollCustomConfig.processos.paginacaoFinalizada = false;
            this.TrfMixInfiniteScrollCustomConfig.processos.listagemCarregando = false;
        },
        hasFases(item) {
            return item.fases != null;
        },
        async paginar(page, limit) {
            this.TrfMixInfiniteScrollCustomConfig.processos.page += 1;
            await this.listarDados(false);
        },
        async listarDados(limparDados) {
            if(limparDados) {
                this.limparDados();
            }

            this.TrfMixInfiniteScrollCustomConfig.processos.listagemCarregando = true;

            const paginacao = this.TrfMixInfiniteScrollCustomConfig.processos;
            const processoService = await this.importProcessoService();

            let filtro = {
                ...this.filtro,
                pagina: paginacao.page,
                limit: paginacao.limit
            }

            const response = await processoService.listar(filtro);
            response.data.forEach(f => {
                const processoDto = this.getProcessoObj(f);
                this.dados.push(processoDto);
            });
           
            this.TrfMixInfiniteScrollCustomConfig.processos.paginacaoFinalizada =
                this.dados.length >= response.totalDeItens;
            this.TrfMixInfiniteScrollCustomConfig.processos.listagemCarregando = false;
        },
        hasDados() {
            return this.dados.length != 0;
        },
        getProcessoObj(processo) {
            const historico = processo.historicoTarefas;
            const prazoFormatado = this.getDataFormatada(historico.prazoEntrega);
            const responsavel = this.listaResponsaveis.find(r => r.value == historico.responsavelId);

            return {
                id: processo.id,
                nomeNegocio: processo.nomeNegocio,
                departamento: processo.departamento,
                dataEntrega: prazoFormatado,
                responsavel: { nome: !responsavel ? "" : responsavel.label },
                fases: historico.fases
                    .map(f => this.getFaseObj(f, prazoFormatado))
                    .sort((a,b) => (a.ordem < b.ordem ? -1 : false))
            }
        },
        getFaseObj(fase, prazoFormatado) {
            const vazio = '- - -';
            const departamento = this.listaDepartamentos.find(d => d.value == fase.departamentoId);
            const responsavel = this.listaResponsaveis.find(r => r.value == fase.responsavelId);

            return {
                ...fase,
                nomeDepartamento: !departamento ? vazio : departamento.label,
                nomeResponsavel: !responsavel ? vazio : responsavel.label,
                dataEntrega: prazoFormatado
            }
        },
        getDataFormatada(data) {
            return utils.formatarDataParaExibicaoNoDataTable(data);
        }
    },
    created() {
        this.TrfMixInfiniteScrollCustomConfig.processos = {
            page: 1,
            limit: 25,
            paginacaoFinalizada: false,
            listagemCarregando: false,
            incrementFn: this.paginar
        }
    }
}
</script>

<style scoped>
.modal-list-content {
  padding: 8px 35px;
  overflow:auto;
  height:100%;
}
</style>

<style lang="scss">
  .tabela-fase-branca table tr {
    background:#FFF!important;
    &:hover {
      background: hsl(0deg, 0%, 96%)!important;
    }
  }

  table {
    & > tr, & > tbody > tr, & > thead > tr {
      & + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:0;
          overflow:hidden;
          padding-top:0;
          padding-bottom:0;
          margin-top:0;
          margin-bottom:0;
          transition: overflow 0s ease-out 0.35s, 0.35s ease-out 0s;
        }
      }
      &.is-toggled + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:1000vh;
          overflow:visible;
          transition: overflow 0s ease-in 0.35s, 0.35s ease-in 0s;
        }
      }
    }
  }
</style>
